import http from "./httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/expenses/";
const url = apiUrl + endPoint;

export async function getExpenses(pageNumber, pageSize, searchQuery) {
  return await http.get(url + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getExpensesCount(searchQuery) {
  return await http.get(url + "count/?searchQuery=" + searchQuery);
}

export async function addExpense(expense) {
  return await http.post(url, expense);
}

export async function deleteExpense(id) {
  return await http.delete(url + "/" + id);
}
